/* istanbul ignore file */
import PropTypes from 'prop-types';
import momentProps from 'react-moment-proptypes';

const locale = PropTypes.objectOf(PropTypes.string);
const jssClass = PropTypes.oneOfType([PropTypes.object, PropTypes.string]);
const jssClasses = PropTypes.objectOf(jssClass);

export default {
  locale,
  jssClass,
  jssClasses,
  momentObj: momentProps.momentObj
};
